let socket;

export const setActiveSocket = (activeSocket) => {
  socket = activeSocket;
};

export const getActiveSocket = () => socket;
